/** Choosing a password, first time or forgotten: the rules for a new one, and what the sign-in page says after a link is asked for. */

/** Supabase Auth's own floor: it refuses anything shorter, so this is as short as a password can be. */
export const MIN_PASSWORD_LENGTH = 6;

/** What stops a new password from being saved, or null when it can be. */
export function passwordProblem(password: string, confirmation: string): string | null {
  if (password.length < MIN_PASSWORD_LENGTH) return `Use at least ${MIN_PASSWORD_LENGTH} characters.`;
  if (password !== confirmation) return 'The passwords do not match.';
  return null;
}

export type ResetOutcome = { tone: 'sent' | 'error'; message: string };

/**
 * What to tell the person after asking for a link (the dashboard-account-link Edge Function, which anyone may use:
 * someone new gets an account, someone known a reset; the link lands on this dashboard's set-password screen). A sent
 * link reads the same for everyone, so the page never reveals who has access.
 */
export function resetOutcome(email: string, error: { status?: number; message?: string } | null): ResetOutcome {
  if (!error) {
    return { tone: 'sent', message: `Check ${email}: a link to choose your password is on its way. It can take a minute or two; check spam too. The link works once, for about an hour.` };
  }
  if (error.status === 429 || /rate limit|too many/i.test(error.message ?? '')) {
    return { tone: 'error', message: 'Too many links were asked for just now. Wait a few minutes, then try again.' };
  }
  if (error.status === 400) return { tone: 'error', message: 'Enter a valid email.' };
  return { tone: 'error', message: 'We couldn’t send that link right now. Try again in a minute; if it keeps failing, ask your account manager for a setup link.' };
}
